import React from 'react';
import { CONTACT, whatsappLink } from '../lib/siteConfig';
import { WhatsAppIcon } from './BrandIcons';

// Mensaje que aparece ya escrito en WhatsApp al abrir el chat. El usuario
// todavia tiene que pulsar enviar; wa.me solo precarga el texto.
const DEFAULT_MESSAGE =
  '¡Hola! Me gustaría más información sobre La Finca, ¿me pueden ayudar por favor?';

// Boton flotante de WhatsApp. Apunta al mismo telefono que el resto del sitio
// (viene de lib/siteConfig). z-40 lo deja por debajo del navbar y del lightbox
// de la galeria, que van en z-50.
export default function WhatsAppButton() {
  return (
    <a
      href={whatsappLink(DEFAULT_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label={`Escríbenos por WhatsApp al ${CONTACT.phoneDisplay}`}
      title="Escríbenos por WhatsApp"
      className="group fixed bottom-6 right-6 z-40 h-14 w-14"
    >
      {/* Onda que se expande. motion-reduce la oculta para quien pidio menos
          animacion en su sistema operativo. */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping motion-reduce:hidden" />

      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 animate-heartbeat group-hover:bg-[#1EBE57] motion-reduce:animate-none">
        <WhatsAppIcon className="h-7 w-7" />
      </span>
    </a>
  );
}
